import { all, takeLatest, call, put } from "redux-saga/effects";
import * as constant from "./constant";
import {
  getProjectedReturnSuccess,
  getProjectedReturnFailed,
  getTotalUnitFundsSuccess,
  getTotalUnitFundsFailed,
  getProjectedReturnInvestSuccess,
  getProjectedReturnInvestFailed,
  updateCustomerDuplicateSuccess,
  updateCustomerDuplicateFailed,
  getRetirementMinAmountSuccess,
  getRetirementMinAmountFailed,
  getRetirementMaxAmountSuccess,
  getRetirementMaxAmountFailed,
  getRetirementCardInfoSuccess,
  getRetirementCardInfoFailed,
  getMinRetirementYearSuccess,
  getMinRetirementYearFailed,
  getMaxRetirementYearSuccess,
  getMaxRetirementYearFailed,
} from "./actions";
import { API_URL } from "../../../utils/axios";
import * as api from "../../../utils/api";

function* updateCustomerDuplicateSaga({ payload, callback }) {
  try {
    // remove undefined/null property from the payload
    Object.keys(payload).forEach(key => !payload[key] && delete payload[key]);

    const res = yield call(api.put, `${API_URL.mp}/mp/customer/delta`, payload);

    if (!Object.keys(res.data).length) {
      throw new Error("Something went wrong!");
    }

    yield put(updateCustomerDuplicateSuccess());
    callback();
  } catch (error) {
    yield put(updateCustomerDuplicateFailed());
  }
}

function* getProjectedReturnSaga() {
  try {
    const res = yield call(
      api.get,
      `${API_URL.mp}/smp/sys-config/getting_started_save_card`
    );
    if (!Object.keys(res.data).length) {
      throw new Error("Something wrong!");
    }
    if (res.data === "Not Found") {
      throw new Error("Something wrong!");
    }

    const { data } = res;

    yield put(getProjectedReturnSuccess(data));
  } catch (error) {
    yield put(getProjectedReturnFailed());
  }
}

function* getRetirementMinAmountSaga() {
  try {
    const res = yield call(
      api.get,
      `${API_URL.mp}/smp/sys-config/retire_min_amount`
    );
    if (!Object.keys(res.data).length) {
      throw new Error("Something wrong!");
    }
    if (res.data === "Not Found") {
      throw new Error("Something wrong!");
    }

    const { data } = res;

    yield put(getRetirementMinAmountSuccess(data));
  } catch (error) {
    yield put(getRetirementMinAmountFailed());
  }
}

function* getRetirementMaxAmountSaga() {
  try {
    const res = yield call(
      api.get,
      `${API_URL.mp}/smp/sys-config/retire_max_amount`
    );
    if (!Object.keys(res.data).length) {
      throw new Error("Something wrong!");
    }
    if (res.data === "Not Found") {
      throw new Error("Something wrong!");
    }

    const { data } = res;

    yield put(getRetirementMaxAmountSuccess(data));
  } catch (error) {
    yield put(getRetirementMaxAmountFailed());
  }
}

function* getMinRetirementYearSaga() {
  try {
    const res = yield call(
      api.get,
      `${API_URL.mp}/smp/sys-config/retire_min_year`
    );
    if (!Object.keys(res.data).length) {
      throw new Error("Something wrong!");
    }
    if (res.data === "Not Found") {
      throw new Error("Something wrong!");
    }

    const { data } = res;

    yield put(getMinRetirementYearSuccess(data));
  } catch (error) {
    yield put(getMinRetirementYearFailed());
  }
}


function* getMaxRetirementYearSaga() {
  try {
    const res = yield call(
      api.get,
      `${API_URL.mp}/smp/sys-config/retire_max_year`
    );
    if (!Object.keys(res.data).length) {
      throw new Error("Something wrong!");
    }
    if (res.data === "Not Found") {
      throw new Error("Something wrong!");
    }

    const { data } = res;

    yield put(getMaxRetirementYearSuccess(data));
  } catch (error) {
    yield put(getMaxRetirementYearFailed());
  }
}

function* getRetirementCardInfoSaga() {
  try {
    const res = yield call(
      api.get,
      `${API_URL.mp}/smp/sys-config/getting_started_retire_card`
    );
    if (!Object.keys(res.data).length) {
      throw new Error("Something wrong!");
    }
    if (res.data === "Not Found") {
      throw new Error("Something wrong!");
    }

    const { data } = res;

    yield put(getRetirementCardInfoSuccess(data));
  } catch (error) {
    yield put(getRetirementCardInfoFailed());
  }
}

function* getTotalUnitFundsSaga({ payload }) {
  try {
    const res = yield call(
      api.get,
      `${API_URL.mp}/smp/product-category/${payload}`
    );
    if (!Object.keys(res.data).length) {
      throw new Error("Something wrong!");
    }
    if (res.data === "Not Found") {
      throw new Error("Something wrong!");
    }
    const { data } = res;

    yield put(getTotalUnitFundsSuccess(data));
  } catch (error) {
    yield put(getTotalUnitFundsFailed());
  }
}

function* getProjectedReturnInvestSaga() {
  try {
    const res = yield call(
      api.get,
      `${API_URL.mp}/smp/sys-config/getting_started_invest_card`
    );
    if (!Object.keys(res.data).length) {
      throw new Error("Something wrong!");
    }
    if (res.data === "Not Found") {
      throw new Error("Something wrong!");
    }

    const { data } = res;

    yield put(getProjectedReturnInvestSuccess(data));
  } catch (error) {
    yield put(getProjectedReturnInvestFailed());
  }
}

export function* getStartedWorkerSaga() {
  yield all([
    takeLatest(constant.GET_PROJECTED_RETURN, getProjectedReturnSaga),
    takeLatest(constant.GET_TOTAL_UNIT_FUNDS, getTotalUnitFundsSaga),
    takeLatest(constant.PROJECTED_RETURN_INVEST, getProjectedReturnInvestSaga),
    takeLatest(constant.UPDATE_CUSTOMER_DUPLICATE, updateCustomerDuplicateSaga),
    takeLatest(constant.GET_RETIREMENT_MIN_AMOUNT, getRetirementMinAmountSaga),
    takeLatest(constant.GET_RETIREMENT_MAX_AMOUNT, getRetirementMaxAmountSaga),
    takeLatest(constant.GET_RETIREMENT_CARD_INFO, getRetirementCardInfoSaga),
    takeLatest(constant.GET_MIN_RETIREMENT_YEAR, getMinRetirementYearSaga),
    takeLatest(constant.GET_MAX_RETIREMENT_YEAR, getMaxRetirementYearSaga),
  ]);
}
